import { Icons, useToggle } from '@commenda/kakashi';
import { CloseCheckoutConfirmationModal } from './Modals/CloseCheckoutConfirmation';

export const BillingPageHeader = ({ onClose }: { onClose: () => void }) => {
  const checkoutModalVisibility = useToggle();
  return (
    <>
      <div className="flex justify-between items-center p-5 border-b border-border-primary">
        <div className="flex items-center gap-3">
          <span className="txt-large-medium text-text-primary">Checkout</span>
        </div>
        <Icons.XClose
          className="size-5 text-text-fg-secondary cursor-pointer"
          onClick={checkoutModalVisibility.show}
        />
      </div>
      <CloseCheckoutConfirmationModal
        isOpen={checkoutModalVisibility.visible}
        onClose={checkoutModalVisibility.hide}
        onConfirm={onClose}
      />
    </>
  );
};
